<template>
	<div>
		<card v-if="detailNew.length > 0" title="Nuevo Producto">
			<div class="table-responsive">
				<div v-for="item in detailNew" :key="item.requestDetail.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.requestDetail.statusColor">
								<span>{{ item.requestDetail.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th>Marca</th>
												<th v-if="item.comercialMixCode">Mezcla Comercial</th>
												<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
												<th>Botellas</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{{ item.requestDetail.brand }}</td>
												<td v-if="item.comercialMixCode">{{ item.comercialMixCode }} {{
													item.comercialMix }}</td>
												<td>{{ item.requestDetail.variety }} {{
													item.requestDetail.valley }} {{ item.requestDetail.quality }}</td>
												<td>{{ item.requestDetail.finalHarvest }}</td><td>{{ item.requestDetail.quantity }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetail.status == 'Desp. Rechazado'">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b>
										{{ item.requestDetail.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.rejectionWineryDispatchReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetailcancelledReason">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.requestDetailcancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<a @click="changeIconCollapse(item.requestDetail.id)" style="width: 100%"
										class="btn btn-info mb-2" data-toggle="collapse"
										:href="'#collapse' + item.requestDetail.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.requestDetail.id">
										Componentes
										<i :id="'icon' + item.requestDetail.id" class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row collapse multi-collapse" :id="'collapse' + item.requestDetail.id">
								<div class="col-md-6">
									<table class="table table-bordered ">
										<thead class="thead-light">
											<tr>
												<th>Capsula</th>
												<td>{{ item.requestDetail.capsuleName }}</td>
											</tr>
											<tr>
												<th>Tapa</th>
												<td>{{ item.requestDetail.cappingName }}</td>
											</tr>
											<tr>
												<th>Caja</th>
												<td>{{ item.requestDetail.boxName }}</td>
											</tr>
											<tr>
												<th>Botella</th>
												<td>{{ item.requestDetail.bottleName }}</td>
											</tr>
										</thead>
									</table>
								</div>
								<div class="col-md-6" v-if="item.requestDetail.isNewComposition == true">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th class="text-white" colspan="2">Nueva Composición</th>
											</tr>
										</thead>
										<thead class="thead-light">
											<tr>
												<th>Variedad</th>
												<th>Porcentaje</th>
											</tr>
											<tr v-for="composition in item.compositions" :key="composition.id">
												<td>{{ composition.variety }}</td>
												<td>{{ composition.percent }}%</td>
											</tr>
										</thead>
									</table>
								</div>
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Obs. Preparación del Vino</th>
												<td>{{ item.requestDetail.preparationRemarks }}</td>
											</tr>
											<tr>
												<th>Glosa Sticker</th>
												<td>{{ item.requestDetail.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.requestDetail.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row" v-if="item.documentFiles">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px;">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' || doc.fileExtension == '.png'"
														class="text-info"><i class="fas fa-image"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' || doc.fileExtension == '.xlsx'"
														class="text-success"><i class="fas fa-file-excel"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' || doc.fileExtension == '.docx'"
														class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)"><i
															class="fa fa-download"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
		<card v-if="detailFinish.length > 0" title="Producto Terminado">
			<div class="table-responsive">
				<div v-for="item in detailFinish" :key="item.requestDetail.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.requestDetail.statusColor">
								<span>{{ item.requestDetail.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<table class="table table-striped table-hover table-bordered">
								<thead class="thead-dark">
									<tr>
										<th>Sku</th>
										<th>Marca</th>
										<th v-if="item.comercialMixCode">Mezcla Comercial</th>
										<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
										<th>Botellas</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ item.requestDetail.sku }}</td>
										<td>{{ item.requestDetail.brand }}</td>
										<td v-if="item.comercialMixCode">{{ item.comercialMixCode }} {{ item.comercialMix }}
										</td>
										<!---<td> <label class="badge badge-secondary">{{ item.requestDetail.variety }}</label> <label class="badge badge-secondary">{{ item.requestDetail.harvest }}</label><label class="badge badge-secondary">{{ item.requestDetail.valley}}</label><label class="badge badge-secondary"> {{ item.requestDetail.quality }}</label> </td>  -->
										<td>{{ item.requestDetail.variety }} {{
											item.requestDetail.valley }} {{ item.requestDetail.quality }}</td>
										<td>{{ item.requestDetail.finalHarvest }}</td><td>{{ item.requestDetail.quantity }}</td>
									</tr>
								</tbody>
							</table>
							<div class="card mb-4 bg-danger" v-if="item.requestDetail.status == 'Desp. Rechazado'">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b>
										{{ item.requestDetail.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetailstatus == 'Invalidado'">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetail.cancelledAt != null">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.requestDetail.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<a @click="changeIconCollapse(item.requestDetail.id)" style="width: 100%"
										class="btn btn-info mb-2" data-toggle="collapse"
										:href="'#collapse' + item.requestDetail.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.requestDetail.id"> Ver más
										<i :id="'icon' + item.requestDetail.id" class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row collapse multi-collapse" :id="'collapse' + item.requestDetail.id">
								<div class="col-md-6">
									<div>
										<table class="table table-striped table-hover table-bordered">
											<thead class="thead-light">
												<tr>
													<th>Componentes</th>
												</tr>
												<tr v-if="item.requestDetail.saleZoneCode != null">
													<th>Zona de venta: <span
															class="ml-2">{{ item.requestDetail.saleZoneCode }}</span></th>
												</tr>
											</thead>
											<tr v-for="lc in item.components" :key="lc.id">
												<td>{{ lc.name }}</td>
											</tr>
											<tr style="color: white; background-color: #6c757d">
												<td><span class="mr-4">Semielaborado:</span>
													{{ item.requestDetail.semiElaborateName }} -
													{{ item.requestDetail.semiElaborateCode }}</td>
											</tr>
											<tr v-if="item.requestDetail.otherSemiElaborateCode" style="color: white; background-color: #6c757d">
												<td colspan="2"><span class="mr-4">Otro Semielaborado:</span></td>
											</tr>
											<tr v-if="item.requestDetail.otherSemiElaborateCode">
												<td>{{ item.requestDetail.otherSemiElaborateCode }}</td>
												<td>{{ item.requestDetail.otherSemiElaborateName }}</td>
											</tr>
										</table>
									</div>
								</div>
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Obs. Preparación del Vino</th>
												<td>{{ item.requestDetail.preparationRemarks }}</td>
											</tr>
											<tr>
												<th>Glosa Sticker</th>
												<td>{{ item.requestDetail.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.requestDetail.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row" v-if="item.documentFiles">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px;">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' || doc.fileExtension == '.png'"
														class="text-info"><i class="fas fa-image"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' || doc.fileExtension == '.xlsx'"
														class="text-success"><i class="fas fa-file-excel"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' || doc.fileExtension == '.docx'"
														class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)"><i
															class="fa fa-download"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
		<card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
			<div class="table-responsive">
				<div v-for="item in detailBottle" :key="item.requestDetail.id">
					<div class="card mb-4 cardShadow">
						<span>
							<div :class="item.requestDetail.statusColor">
								<span>{{ item.requestDetail.status }}</span>
							</div>
						</span>
						<div class="card-body">
							<table class="table table-striped table-hover table-bordered">
								<thead class="thead-dark">
									<tr>
										<th>Código</th>
										<th v-if="item.comercialMixCode">Mezcla Comercial</th>
										<th>Marca</th>
										<th>Vino</th><th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
										<th>Botellas</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{ item.requestDetail.sku }}</td>
										<td>{{ item.requestDetail.brand }}</td>
										<td v-if="item.comercialMixCode">{{ item.comercialMixCode }} {{ item.comercialMix }}
										</td>
										<td>{{ item.requestDetail.variety }} {{
											item.requestDetail.valley }} {{ item.requestDetail.quality }}</td>
										<td>{{ item.requestDetail.finalHarvest }}</td><td>{{ item.requestDetail.quantity }}</td>
									</tr>
								</tbody>
							</table>
							<div class="card mb-4 bg-danger" v-if="item.requestDetail.status == 'Desp. Rechazado'">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b>
										{{ item.requestDetail.rejectionReason }}</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetailstatus == 'Invalidado'">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div class="card mb-4 bg-danger" v-if="item.requestDetail.cancelledAt != null">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.requestDetail.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<a @click="changeIconCollapse(item.requestDetail.id)" style="width: 100%"
										class="btn btn-info mb-2" data-toggle="collapse"
										:href="'#collapse' + item.requestDetail.id" role="button" aria-expanded="false"
										:aria-controls="'collapse' + item.requestDetail.id"> Ver más
										<i :id="'icon' + item.requestDetail.id" class="fas fa-angle-down ml-4"></i>
									</a>
								</div>
							</div>
							<div class="row collapse multi-collapse" :id="'collapse' + item.requestDetail.id">
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr v-if="item.requestDetail.capsuleName">
												<th>Capsula</th>
												<td>{{ item.requestDetail.capsuleName }}</td>
											</tr>
											<tr v-if="item.requestDetail.cappingName">
												<th>Tapa</th>
												<td>{{ item.requestDetail.cappingName }}</td>
											</tr>
											<tr v-if="item.requestDetail.boxName">
												<th>Caja</th>
												<td>{{ item.requestDetail.boxName }}</td>
											</tr>
											<tr v-if="item.requestDetail.bottleName">
												<th>Botella</th>
												<td>{{ item.requestDetail.bottleName }}</td>
											</tr>
										</thead>
									</table>
								</div>
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Obs. Preparación del Vino</th>
												<td>{{ item.requestDetail.preparationRemarks }}</td>
											</tr>
											<tr>
												<th>Glosa Sticker</th>
												<td>{{ item.requestDetail.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.requestDetail.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row" v-if="item.documentFiles">
								<div class="col-md-12">
									<table class="table table-stripped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px;">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															class="fas fa-file-pdf" aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.jpg' || doc.fileExtension == '.png'"
														class="text-info"><i class="fas fa-image"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.xls' || doc.fileExtension == '.xlsx'"
														class="text-success"><i class="fas fa-file-excel"
															aria-hidden="true"></i></span>
													<span v-if="doc.fileExtension == '.doc' || doc.fileExtension == '.docx'"
														class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)"><i
															class="fa fa-download"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</card>
	</div>
</template>
<script>
import $ from "jquery";
export default {
	props: ["details", "id", "components"],
	data() {
		return {
			apiUrl: this.$store.getters.apiUrl,
		};
	},
	methods: {
		changeIconCollapse(item) {
			if ($('#icon' + item).hasClass('fa-angle-down')) {
				$('#icon' + item).toggleClass("fa-angle-up")
			}
			else if ($('#icon' + item).hasClass('fa-angle-up')) {
				$('#icon' + item).toggleClass("fa-angle-down")
			}
		},
		downloadFile(id) {
			window.open(`${this.apiUrl}v1/documentfile/${id}`);
		}
	},
	computed: {
		detailNew: function () {
			return this.details.filter((x) => x.requestDetail.requestTypeId === 1);
		},
		detailFinish: function () {
			return this.details.filter((x) => x.requestDetail.requestTypeId === 2);
		},
		detailBottle: function () {
			return this.details.filter((x) => x.requestDetail.requestTypeId === 3);
		},

	},
};
</script>